import * as permissions from './Permissions'
import { Subscriptions } from '@carsys/enums/subscription'

const PermissionsModule0 = [
  permissions.PERMISSION_ANY,
  permissions.PERMISSION_ACCOUNT_READ,
  permissions.PERMISSION_ACCOUNT_CREATE,
  permissions.PERMISSION_ACCOUNT_DELETE,
  permissions.PERMISSION_ACCOUNT_UPDATE,

  permissions.PERMISSION_APPOINTMENT_PROPOSAL_READ,
  permissions.PERMISSION_APPOINTMENT_PROPOSAL_UPDATE,
  permissions.PERMISSION_INTAKE_PROPOSAL_READ,
  permissions.PERMISSION_INTAKE_PROPOSAL_UPDATE,

  permissions.PERMISSION_ORDERACCOUNT_READ,

  permissions.PERMISSION_SHOP_READ,
  permissions.PERMISSION_SHOP_UPDATE,

  permissions.PERMISSION_WORKHOURS_CREATE,
  permissions.PERMISSION_WORKHOURS_READ,
  permissions.PERMISSION_WORKHOURS_UPDATE,
  permissions.PERMISSION_WORKHOURS_DELETE,

  permissions.PERMISSION_EMPLOYEE_CREATE,
  permissions.PERMISSION_EMPLOYEE_READ,
  permissions.PERMISSION_EMPLOYEE_UPDATE,
  permissions.PERMISSION_EMPLOYEE_DELETE,

  permissions.PERMISSION_ACTIVITY_CREATE,
  permissions.PERMISSION_ACTIVITY_READ,
  permissions.PERMISSION_ACTIVITY_UPDATE,
  permissions.PERMISSION_ACTIVITY_DELETE,

  permissions.PERMISSION_WO_PACKAGES_READ,

  permissions.PERMISSION_LABOURRATE_CREATE,
  permissions.PERMISSION_LABOURRATE_READ,
  permissions.PERMISSION_LABOURRATE_UPDATE,
  permissions.PERMISSION_LABOURRATE_DELETE,

  permissions.PERMISSION_SUNDRIES_READ,
  permissions.PERMISSION_SUNDRIES_UPDATE,

  permissions.PERMISSION_ABSENCESCHEDULE_CREATE,
  permissions.PERMISSION_ABSENCESCHEDULE_READ,
  permissions.PERMISSION_ABSENCESCHEDULE_UPDATE,
  permissions.PERMISSION_ABSENCESCHEDULE_DELETE,

  permissions.PERMISSION_CONCEPT_CREATE,
  permissions.PERMISSION_CONCEPT_READ,
  permissions.PERMISSION_CONCEPT_UPDATE,
  permissions.PERMISSION_CONCEPT_DELETE,

  permissions.PERMISSION_CONCEPT_READ_TENDERS,

  permissions.PERMISSION_HAYNESPROIFRAME_READ,
  permissions.PERMISSION_THIRDPARTYLICENSE_READ,

  permissions.PERMISSION_LINKS_WIDGET,
  permissions.PERMISSION_CONCEPT_APP,
  permissions.PERMISSION_TYRE_WARRANTY,
  permissions.PERMISSION_WOM_PLUS
]

const PermissionsModuleGMS = [
  permissions.PERMISSION_DASHBOARD,

  permissions.PERMISSION_APPOINTMENT_CREATE,
  permissions.PERMISSION_APPOINTMENT_READ,
  permissions.PERMISSION_APPOINTMENT_UPDATE,
  permissions.PERMISSION_APPOINTMENT_DELETE,
  permissions.PERMISSION_APPOINTMENT_CAN_ASSIGN_MECHANIC,
  permissions.PERMISSION_APPOINTMENT_CAN_ASSIGN_WORKSTATION,
  permissions.PERMISSION_APPOINTMENT_CAN_VIEW_MONTH,
  permissions.PERMISSION_APPOINTMENT_CAN_PLAN_WORKORDER,
  permissions.PERMISSION_APPOINTMENT_CAN_PLAN_PROPOSAL,
  permissions.PERMISSION_APPOINTMENT_CAN_DRAG_ITEM,

  permissions.PERMISSION_CLOSINGSTATEMENT_READ,

  permissions.PERMISSION_APPOINTMENT_PROPOSAL_READ,
  permissions.PERMISSION_APPOINTMENT_PROPOSAL_CONVERT,
  permissions.PERMISSION_APPOINTMENT_PROPOSAL_UPDATE,
  permissions.PERMISSION_INTAKE_PROPOSAL_READ,
  permissions.PERMISSION_INTAKE_PROPOSAL_CONVERT,
  permissions.PERMISSION_INTAKE_PROPOSAL_UPDATE,

  permissions.PERMISSION_SCHEDULER_SETTINGS,

  permissions.PERMISSION_STOCK_SETTINGS,

  permissions.PERMISSION_PART_CREATE,
  permissions.PERMISSION_PART_READ,
  permissions.PERMISSION_PART_UPDATE,
  permissions.PERMISSION_PART_DELETE,

  permissions.PERMISSION_RECEIVE_STOCK_READ,
  permissions.PERMISSION_ORDER_SUGGESTION_READ,

  permissions.PERMISSION_VEHICLE_CREATE,
  permissions.PERMISSION_VEHICLE_READ,
  permissions.PERMISSION_VEHICLE_UPDATE,
  permissions.PERMISSION_VEHICLE_DELETE,

  permissions.PERMISSION_VEHICLE_SEARCH_BY_COUNTRY,

  permissions.PERMISSION_WORKORDER_CREATE,
  permissions.PERMISSION_WORKORDER_READ,
  permissions.PERMISSION_WORKORDER_UPDATE,
  permissions.PERMISSION_WORKORDER_DELETE,

  permissions.PERMISSION_WORKORDER_REMARK,
  permissions.PERMISSION_WORKORDER_IMAGES,
  permissions.PERMISSION_WORKORDER_PRINT,
  permissions.PERMISSION_WORKORDER_INVOICE_CREATE,
  permissions.PERMISSION_WORKORDER_INVOICE_READ,

  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_CREATE,
  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_READ,
  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_UPDATE,
  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_DELETE,

  permissions.PERMISSION_WORKORDERNUMBER_READ,
  permissions.PERMISSION_WORKORDERNUMBER_UPDATE,

  permissions.PERMISSION_WORKORDER_QUOTATIONS_READ,
  permissions.PERMISSION_WORKORDER_QUOTATIONS_UPDATE,

  permissions.PERMISSION_WARRANTY_CLAIMS_READ,
  permissions.PERMISSION_WARRANTY_CLAIMS_UPDATE,

  permissions.PERMISSION_PRICEMARKUP_READ,
  permissions.PERMISSION_PRICEMARKUP_UPDATE,

  permissions.PERMISSION_INVOICESEQUENCE_CREATE,
  permissions.PERMISSION_INVOICESEQUENCE_READ,
  permissions.PERMISSION_INVOICESEQUENCE_UPDATE,
  permissions.PERMISSION_INVOICESEQUENCE_DELETE,

  permissions.PERMISSION_ORDER_PRINT,
  permissions.PERMISSION_ORDER_RECEIVE,

  permissions.PERMISSION_RMA_CREATE,
  permissions.PERMISSION_RMA_READ,

  permissions.PERMISSION_ORDERACCOUNT_READ,
  permissions.PERMISSION_ORDERACCOUNT_UPDATE,
  permissions.PERMISSION_ORDERACCOUNT_DELETE,
  permissions.PERMISSION_ORDERACCOUNT_HIDE,

  permissions.PERMISSION_DEBITCREDIT_READ,
  permissions.PERMISSION_DEBITCREDIT_UPDATE,

  permissions.PERMISSION_DEFAULTSTOCK_READ,
  permissions.PERMISSION_DEFAULTSTOCK_UPDATE,

  permissions.PERMISSION_EMPLOYEESKILL_CREATE,
  permissions.PERMISSION_EMPLOYEESKILL_READ,
  permissions.PERMISSION_EMPLOYEESKILL_UPDATE,
  permissions.PERMISSION_EMPLOYEESKILL_DELETE,

  permissions.PERMISSION_ADMINISTRATION_CREATE,
  permissions.PERMISSION_ADMINISTRATION_READ,
  permissions.PERMISSION_ADMINISTRATION_UPDATE,
  permissions.PERMISSION_ADMINISTRATION_DELETE,

  permissions.PERMISSION_LEDGER_CREATE,
  permissions.PERMISSION_LEDGER_READ,
  permissions.PERMISSION_LEDGER_UPDATE,
  permissions.PERMISSION_LEDGER_DELETE,

  permissions.PERMISSION_REVENUEGROUP_CREATE,
  permissions.PERMISSION_REVENUEGROUP_READ,
  permissions.PERMISSION_REVENUEGROUP_UPDATE,
  permissions.PERMISSION_REVENUEGROUP_DELETE,

  permissions.PERMISSION_PAYMENTMETHOD_CREATE,
  permissions.PERMISSION_PAYMENTMETHOD_READ,
  permissions.PERMISSION_PAYMENTMETHOD_UPDATE,
  permissions.PERMISSION_PAYMENTMETHOD_DELETE,

  permissions.PERMISSION_CLOCKREGISTRATION_CREATE,
  permissions.PERMISSION_CLOCKREGISTRATION_READ,
  permissions.PERMISSION_CLOCKREGISTRATION_UPDATE,
  permissions.PERMISSION_CLOCKREGISTRATION_DELETE,

  permissions.PERMISSION_WORKORDERINVOICEEXPORT_CREATE,
  permissions.PERMISSION_WORKORDERINVOICEEXPORT_READ,
  permissions.PERMISSION_WORKORDERINVOICEEXPORT_UPDATE,
  permissions.PERMISSION_WORKORDERINVOICEEXPORT_DELETE,

  permissions.PERMISSION_INVOICE_CREATE,
  permissions.PERMISSION_INVOICE_READ,
  permissions.PERMISSION_INVOICE_UPDATE,
  permissions.PERMISSION_INVOICE_DELETE,

  permissions.PERMISSION_PARTGROUP_CREATE,
  permissions.PERMISSION_PARTGROUP_READ,
  permissions.PERMISSION_PARTGROUP_UPDATE,
  permissions.PERMISSION_PARTGROUP_DELETE,

  permissions.PERMISSION_REPORTING_READ,

  permissions.PERMISSION_SMS_CREATE,
  permissions.PERMISSION_SMS_READ,
  permissions.PERMISSION_SMS_UPDATE,
  permissions.PERMISSION_SMS_DELETE,

  permissions.PERMISSION_HAYNES_CREATE,
  permissions.PERMISSION_HAYNES_READ,
  permissions.PERMISSION_HAYNES_UPDATE,

  permissions.PERMISSION_EMAILSETTINGS_CREATE,
  permissions.PERMISSION_EMAILSETTINGS_READ,
  permissions.PERMISSION_EMAILSETTINGS_UPDATE,
  permissions.PERMISSION_EMAILSETTINGS_DELETE,

  permissions.PERMISSION_BCC_EMAIL,

  permissions.PERMISSION_EMAILHISTORY_CREATE,
  permissions.PERMISSION_EMAILHISTORY_READ,
  permissions.PERMISSION_EMAILHISTORY_UPDATE,
  permissions.PERMISSION_EMAILHISTORY_DELETE,

  permissions.PERMISSION_SMSHISTORY_CREATE,
  permissions.PERMISSION_SMSHISTORY_READ,
  permissions.PERMISSION_SMSHISTORY_UPDATE,
  permissions.PERMISSION_SMSHISTORY_DELETE,

  permissions.PERMISSION_HISTORYRECORD_CREATE,
  permissions.PERMISSION_HISTORYRECORD_READ,
  permissions.PERMISSION_HISTORYRECORD_UPDATE,
  permissions.PERMISSION_HISTORYRECORD_DELETE,

  permissions.PERMISSION_HISTORYORDER_CREATE,
  permissions.PERMISSION_HISTORYORDER_READ,
  permissions.PERMISSION_HISTORYORDER_UPDATE,
  permissions.PERMISSION_HISTORYORDER_DELETE,

  permissions.PERMISSION_OKRHISTORY_READ,
  permissions.PERMISSION_OKRHISTORY_UPDATE,

  permissions.PERMISSION_WORKORDERLINE_LABOURRATE_CREATE,
  permissions.PERMISSION_WORKORDERLINE_LABOURRATE_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_LABOURRATE_DELETE,

  permissions.PERMISSION_WORKORDERLINE_ACTIVITY_CREATE,
  permissions.PERMISSION_WORKORDERLINE_ACTIVITY_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_ACTIVITY_DELETE,

  permissions.PERMISSION_WORKORDERLINE_CHAPTER_CREATE,

  permissions.PERMISSION_WORKORDERLINE_PART_CREATE,
  permissions.PERMISSION_WORKORDERLINE_PART_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_PART_DELETE,

  permissions.PERMISSION_WORKORDERLINE_UNIVERSALPART_CREATE,
  permissions.PERMISSION_WORKORDERLINE_UNIVERSALPART_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_UNIVERSALPART_DELETE,

  permissions.PERMISSION_WORKORDERLINE_TOOLSPECIAL_CREATE,
  permissions.PERMISSION_WORKORDERLINE_TOOLSPECIAL_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_TOOLSPECIAL_DELETE,

  permissions.PERMISSION_WORKORDERLINE_STATUS_TOGGLE,

  permissions.PERMISSION_WORKORDERLINE_DISCOUNT_CREATE,

  permissions.PERMISSION_WO_DEFAULT_TEXT_LINES,
  permissions.PERMISSION_WO_DEFAULT_CUSTOM_LINES,

  permissions.PERMISSION_RDWPROVIDERACCOUNT_CREATE,
  permissions.PERMISSION_RDWPROVIDERACCOUNT_READ,
  permissions.PERMISSION_RDWPROVIDERACCOUNT_UPDATE,
  permissions.PERMISSION_RDWPROVIDERACCOUNT_DELETE,

  permissions.PERMISSION_WORKORDERLINE_SUNDRIES_CREATE,
  permissions.PERMISSION_WORKORDERLINE_SUNDRIES_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_SUNDRIES_DELETE,

  permissions.PERMISSION_HISTORY,
  permissions.PERMISSION_VEHICLESALES_READ,

  permissions.PERMISSION_ACCOUNT_CREATE_PRIVATE,
  permissions.PERMISSION_ACCOUNT_READ_PRIVATE,

  permissions.PERMISSION_COMPANYACCOUNT_CREATE,
  permissions.PERMISSION_COMPANYACCOUNT_READ,
  permissions.PERMISSION_COMPANYACCOUNT_UPDATE,
  permissions.PERMISSION_COMPANYACCOUNT_DELETE,

  permissions.PERMISSION_EXTERNALINVOICE_READ,

  permissions.PERMISSION_VAT_RETURN_READ,

  // APK Permission
  permissions.PERMISSION_MOT_RDW,
  permissions.PERMISSION_IMPORT_DATA,

  permissions.PERMISSION_HAYNESCHECKLIST_UPDATE,

  permissions.PERMISSION_EXTERNAL_PARTS_SETTINGS_READ,
  permissions.PERMISSION_EXTERNAL_PARTS_SETTINGS_UPDATE,
  permissions.PERMISSION_MEDIA,

  permissions.PERMISSION_WORKSTATION_READ,
  permissions.PERMISSION_THIRDPARTYLICENSE_READ,

  permissions.PERMISSION_MYKAR_READ,

  permissions.PERMISSION_PAYMENT_PROVIDERS_READ,

  permissions.PERMISSION_SURVEY_PROVIDERS_READ,

  permissions.PEMRISSION_ROAD_ASSISTANCE,

  permissions.PERMISSION_TIME_CORRECTION,

  permissions.PERMISSION_TYRE_STORAGE,

  permissions.PERMISSION_CONCEPT_APP,
  permissions.PERMISSION_TYRE_WARRANTY,

  permissions.PERMISSION_RETURNS_SHOP_SETTING_READ,

  permissions.PERMISSION_LEASE_WORKORDER_SWITCH,

  permissions.PERMISSION_GENART_ADD_FROM_OFFLINE_PURCHASE,

  permissions.PERMISSION_GENART_ADD_FROM_STOCK,

  permissions.PERMISSION_BACK_TO_WORK_ORDER_ARROW_BUTTON,

  permissions.PERMISSION_ACTION_CREATE,
  permissions.PERMISSION_ACTION_READ,
  permissions.PERMISSION_ACTION_UPDATE,
  permissions.PERMISSION_ACTION_DELETE,
  permissions.PERMISSION_WOM_PLUS,
  permissions.PERMISSION_EXTERNAL_WEBSITES
]

const PermissionsModulePortal = [
  permissions.PERMISSION_ACCOUNT_CREATE_PRIVATE,
  permissions.PERMISSION_ACCOUNT_CREATE_PRIVATE_SIMPLE,
  permissions.PERMISSION_ACCOUNT_READ_PRIVATE,

  permissions.PERMISSION_ACTIVITY_CREATE,
  permissions.PERMISSION_ACTIVITY_READ,
  permissions.PERMISSION_ACTIVITY_UPDATE,
  permissions.PERMISSION_ACTIVITY_DELETE,

  permissions.PERMISSION_ARCHIVEORDER_CREATE,
  permissions.PERMISSION_ARCHIVEORDER_READ,
  permissions.PERMISSION_ARCHIVEORDER_UPDATE,
  permissions.PERMISSION_ARCHIVEORDER_DELETE,

  permissions.PERMISSION_CLOSINGSTATEMENT_READ,

  permissions.PERMISSION_COMPANYACCOUNT_CREATE,
  permissions.PERMISSION_COMPANYACCOUNT_READ,
  permissions.PERMISSION_COMPANYACCOUNT_UPDATE,
  permissions.PERMISSION_COMPANYACCOUNT_DELETE,

  permissions.PERMISSION_DASHBOARD,
  permissions.PERMISSION_DASHBOARD_PRODUCT_SEARCH,

  permissions.PERMISSION_HAYNES_CREATE,
  permissions.PERMISSION_HAYNES_READ,
  permissions.PERMISSION_HAYNES_UPDATE,

  permissions.PERMISSION_EMAILSETTINGS_CREATE,
  permissions.PERMISSION_EMAILSETTINGS_READ,
  permissions.PERMISSION_EMAILSETTINGS_UPDATE,
  permissions.PERMISSION_EMAILSETTINGS_DELETE,

  permissions.PERMISSION_EMAILHISTORY_CREATE,
  permissions.PERMISSION_EMAILHISTORY_READ,
  permissions.PERMISSION_EMAILHISTORY_UPDATE,
  permissions.PERMISSION_EMAILHISTORY_DELETE,

  permissions.PERMISSION_LABOURRATE_CREATE,
  permissions.PERMISSION_LABOURRATE_READ,
  permissions.PERMISSION_LABOURRATE_UPDATE,
  permissions.PERMISSION_LABOURRATE_DELETE,

  permissions.PERMISSION_ORDER_PRINT,

  permissions.PERMISSION_ORDER_QUOTATIONS_READ,
  permissions.PERMISSION_ORDER_QUOTATIONS_UPDATE,

  permissions.PERMISSION_ORDERS_CREATE,
  permissions.PERMISSION_ORDERS_READ,
  permissions.PERMISSION_ORDERS_UPDATE,
  permissions.PERMISSION_ORDERS_DELETE,

  permissions.PERMISSION_RMA_CREATE,
  permissions.PERMISSION_RMA_READ,

  permissions.PERMISSION_ORDERACCOUNT_READ,
  permissions.PERMISSION_ORDERACCOUNT_UPDATE,
  permissions.PERMISSION_ORDERACCOUNT_DELETE,
  permissions.PERMISSION_ORDERACCOUNT_HIDE,

  permissions.PERMISSION_QUOTATIONCLOSINGSTATEMENT_CREATE,
  permissions.PERMISSION_QUOTATIONCLOSINGSTATEMENT_READ,
  permissions.PERMISSION_QUOTATIONCLOSINGSTATEMENT_UPDATE,
  permissions.PERMISSION_QUOTATIONCLOSINGSTATEMENT_DELETE,

  permissions.PERMISSION_HISTORY,

  permissions.PERMISSION_VEHICLE_CREATE,
  permissions.PERMISSION_VEHICLE_READ,
  permissions.PERMISSION_VEHICLE_UPDATE,
  permissions.PERMISSION_VEHICLE_DELETE,

  permissions.PERMISSION_VEHICLE_SEARCH_BY_COUNTRY,

  permissions.PERMISSION_PRICEMARKUP_READ,
  permissions.PERMISSION_PRICEMARKUP_UPDATE,

  permissions.PERMISSION_WORKORDERLINE_UNIVERSALPART_CREATE,
  permissions.PERMISSION_WORKORDERLINE_UNIVERSALPART_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_UNIVERSALPART_DELETE,

  permissions.PERMISSION_WORKORDERLINE_TOOLSPECIAL_CREATE,
  permissions.PERMISSION_WORKORDERLINE_TOOLSPECIAL_UPDATE,
  permissions.PERMISSION_WORKORDERLINE_TOOLSPECIAL_DELETE,

  permissions.PERMISSION_WORKORDERLINE_STATUS_TOGGLE,
  permissions.PERMISSION_THIRDPARTYLICENSE_READ,

  permissions.PERMISSION_INTAKE_PROPOSAL_READ,
  permissions.PERMISSION_INTAKE_PROPOSAL_CONVERT,
  permissions.PERMISSION_INTAKE_PROPOSAL_UPDATE,

  permissions.PERMISSION_APPOINTMENT_READ,
  permissions.PERMISSION_APPOINTMENT_UPDATE,
  permissions.PERMISSION_APPOINTMENT_DELETE,
  permissions.PERMISSION_APPOINTMENT_CAN_PLAN_PROPOSAL,

  permissions.PERMISSION_RETURNS_SHOP_SETTING_READ,

  permissions.PERMISSION_WORKORDERLINE_DISCOUNT_CREATE,
  permissions.PERMISSION_TYRE_WARRANTY
]

const PermissionsModuleTimeregistration = [
  permissions.PERMISSION_CLOCKINGACTIONS_DAY,
  permissions.PERMISSION_CLOCKINGACTIONS_ITEMS,
  permissions.PERMISSION_CLOCKINGACTIONS_READ,
  permissions.PERMISSION_CLOCKINGACTIONS_WORKORDER,

  permissions.PERMISSION_CLOCKREGISTRATION_CREATE,
  permissions.PERMISSION_CLOCKREGISTRATION_READ,
  permissions.PERMISSION_CLOCKREGISTRATION_UPDATE,
  permissions.PERMISSION_CLOCKREGISTRATION_DELETE,

  permissions.PERMISSION_CLOCKITEMS_CREATE,
  permissions.PERMISSION_CLOCKITEMS_READ,
  permissions.PERMISSION_CLOCKITEMS_UPDATE,
  permissions.PERMISSION_CLOCKITEMS_DELETE,
  permissions.PERMISSION_STATS_READ,
  permissions.PERMISSION_STATS_CLOCKED_READ,
  permissions.PERMISSION_STATS_TIMESHEET_READ
]

const PermissionsModuleSupport = [
  permissions.PERMISSION_ANY,
  permissions.PERMISSION_ACCOUNT_READ,

  permissions.PERMISSION_SHOP_READ,
  permissions.PERMISSION_SHOP_UPDATE,

  permissions.PERMISSION_CONCEPT_READ,
  permissions.PERMISSION_CONCEPT_UPDATE,
  permissions.PERMISSION_CONCEPT_UPDATE_BRANDS,
  permissions.PERMISSION_CONCEPT_UPDATE_IMAGES,

  permissions.PERMISSION_ORDERACCOUNT_CREATE,
  permissions.PERMISSION_ORDERACCOUNT_READ,
  permissions.PERMISSION_ORDERACCOUNT_UPDATE,
  permissions.PERMISSION_ORDERACCOUNT_DELETE,

  permissions.PERMISSION_SWITCH_DEFAULT_ORDER_ACCOUNT,

  permissions.PERMISSION_IMPORT_DATA,

  permissions.PERMISSION_LABOURRATE_CREATE,
  permissions.PERMISSION_LABOURRATE_READ,
  permissions.PERMISSION_LABOURRATE_UPDATE,
  permissions.PERMISSION_LABOURRATE_DELETE,

  permissions.PERMISSION_WORKHOURS_CREATE,
  permissions.PERMISSION_WORKHOURS_READ,
  permissions.PERMISSION_WORKHOURS_UPDATE,
  permissions.PERMISSION_WORKHOURS_DELETE,

  permissions.PERMISSION_ABSENCESCHEDULE_CREATE,
  permissions.PERMISSION_ABSENCESCHEDULE_READ,
  permissions.PERMISSION_ABSENCESCHEDULE_UPDATE,
  permissions.PERMISSION_ABSENCESCHEDULE_DELETE,

  permissions.PERMISSION_RETURNS_SHOP_SETTING_READ,

  permissions.PERMISSION_LEASECOMPANY
]

const PermissionsModuleCRM = [
  permissions.PERMISSION_ANY,
  permissions.PERMISSION_CRM_READ,
  permissions.PERMISSION_CRM_CREATE,
  permissions.PERMISSION_CRM_UPDATE,
  permissions.PERMISSION_CRM_DELETE,
  permissions.PERMISSION_CRM_ACCOUNT_COMMUNICATIONCHANNEL_UPDATE
]

const PermissionsModuleVehicleSales = [
  permissions.PERMISSION_ANY,
  permissions.PERMISSION_STOCK_SETTINGS,
  permissions.PERMISSION_VEHICLESALES_MODULE,
  permissions.PERMISSION_VEHICLESALES_READ,
  permissions.PERMISSION_VEHICLESALES_CREATE,
  permissions.PERMISSION_VEHICLESALES_UPDATE,
  permissions.PERMISSION_VEHICLESALES_DELETE,

  permissions.PERMISSION_CLOSINGSTATEMENT_READ,

  permissions.PERMISSION_VEHICLE_CREATE,
  permissions.PERMISSION_VEHICLE_READ,
  permissions.PERMISSION_VEHICLE_UPDATE,
  permissions.PERMISSION_VEHICLE_DELETE,

  permissions.PERMISSION_VEHICLE_SEARCH_BY_COUNTRY,

  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_CREATE,
  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_READ,
  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_UPDATE,
  permissions.PERMISSION_INVOICECLOSINGSTATEMENT_DELETE,

  permissions.PERMISSION_INVOICESEQUENCE_CREATE,
  permissions.PERMISSION_INVOICESEQUENCE_READ,
  permissions.PERMISSION_INVOICESEQUENCE_UPDATE,
  permissions.PERMISSION_INVOICESEQUENCE_DELETE,

  permissions.PERMISSION_DEBITCREDIT_READ,
  permissions.PERMISSION_DEBITCREDIT_UPDATE,

  permissions.PERMISSION_ADMINISTRATION_CREATE,
  permissions.PERMISSION_ADMINISTRATION_READ,
  permissions.PERMISSION_ADMINISTRATION_UPDATE,
  permissions.PERMISSION_ADMINISTRATION_DELETE,

  permissions.PERMISSION_LEDGER_CREATE,
  permissions.PERMISSION_LEDGER_READ,
  permissions.PERMISSION_LEDGER_UPDATE,
  permissions.PERMISSION_LEDGER_DELETE,

  permissions.PERMISSION_REVENUEGROUP_CREATE,
  permissions.PERMISSION_REVENUEGROUP_READ,
  permissions.PERMISSION_REVENUEGROUP_UPDATE,
  permissions.PERMISSION_REVENUEGROUP_DELETE,

  permissions.PERMISSION_PAYMENTMETHOD_CREATE,
  permissions.PERMISSION_PAYMENTMETHOD_READ,
  permissions.PERMISSION_PAYMENTMETHOD_UPDATE,
  permissions.PERMISSION_PAYMENTMETHOD_DELETE,

  permissions.PERMISSION_WORKORDERINVOICEEXPORT_CREATE,
  permissions.PERMISSION_WORKORDERINVOICEEXPORT_READ,
  permissions.PERMISSION_WORKORDERINVOICEEXPORT_UPDATE,
  permissions.PERMISSION_WORKORDERINVOICEEXPORT_DELETE,

  permissions.PERMISSION_REPORTING_READ,

  permissions.PERMISSION_EMAILSETTINGS_CREATE,
  permissions.PERMISSION_EMAILSETTINGS_READ,
  permissions.PERMISSION_EMAILSETTINGS_UPDATE,
  permissions.PERMISSION_EMAILSETTINGS_DELETE,

  permissions.PERMISSION_BCC_EMAIL,

  permissions.PERMISSION_EMAILHISTORY_CREATE,
  permissions.PERMISSION_EMAILHISTORY_READ,
  permissions.PERMISSION_EMAILHISTORY_UPDATE,
  permissions.PERMISSION_EMAILHISTORY_DELETE,

  permissions.PERMISSION_HISTORY,

  permissions.PERMISSION_ACCOUNT_CREATE_PRIVATE,
  permissions.PERMISSION_ACCOUNT_READ_PRIVATE,

  permissions.PERMISSION_COMPANYACCOUNT_CREATE,
  permissions.PERMISSION_COMPANYACCOUNT_READ,
  permissions.PERMISSION_COMPANYACCOUNT_UPDATE,
  permissions.PERMISSION_COMPANYACCOUNT_DELETE,

  permissions.PERMISSION_INVOICE_CREATE
]

const PermissionsModuleCounter = [
  permissions.PERMISSION_ANY,
  permissions.PERMISSION_COUNTER_SETTINGS,
  permissions.PERMISSION_COUNTER_READ,
  permissions.PERMISSION_COUNTER_CREATE,
  permissions.PERMISSION_COUNTER_UPDATE,
  permissions.PERMISSION_COUNTER_DELETE
]

// eslint-disable-next-line prettier/prettier
const PermissionsModuleTyreChange = [permissions.PERMISSION_TYRE_CHANGE_READ, permissions.PERMISSION_TYRE_CHANGE_UPDATE]

const PermissionsModuleCourtesyVehicles = [
  permissions.PERMISSION_COURTESYVEHICLES_READ,
  permissions.PERMISSION_COURTESYVEHICLES_UPDATE,
  permissions.PERMISSION_REPLACEMENTVEHICLES_SETTINGS_READ,
  permissions.PERMISSION_REPLACEMENTVEHICLES_SETTINGS_UPDATE
]

const PermissionsModuleRentalVehicles = [
  permissions.PERMISSION_RENTALVEHICLES_READ,
  permissions.PERMISSION_RENTALVEHICLES_UPDATE,
  permissions.PERMISSION_REPLACEMENTVEHICLES_SETTINGS_READ,
  permissions.PERMISSION_REPLACEMENTVEHICLES_SETTINGS_UPDATE
]

const PermissionsModuleFleetLeaseWhiteLabel = [
  permissions.PERMISSION_WORKORDER_CREATE,
  permissions.PERMISSION_WORKORDER_READ,
  permissions.PERMISSION_WORKORDER_UPDATE,
  permissions.PERMISSION_WORKORDER_DELETE,
  permissions.PERMISSION_WORKORDERLINE_LABOURRATE_CREATE,
  permissions.PERMISSION_WORKORDERLINE_SUNDRIES_CREATE,

  permissions.PERMISSION_ACCOUNT_CREATE_PRIVATE,
  permissions.PERMISSION_ACCOUNT_READ_PRIVATE,

  permissions.PERMISSION_ACTIVITY_CREATE,
  permissions.PERMISSION_ACTIVITY_READ,
  permissions.PERMISSION_ACTIVITY_UPDATE,
  permissions.PERMISSION_ACTIVITY_DELETE,

  permissions.PERMISSION_COMPANYACCOUNT_CREATE,
  permissions.PERMISSION_COMPANYACCOUNT_READ,
  permissions.PERMISSION_COMPANYACCOUNT_UPDATE,
  permissions.PERMISSION_COMPANYACCOUNT_DELETE,

  permissions.PERMISSION_DASHBOARD,

  permissions.PERMISSION_LABOURRATE_CREATE,
  permissions.PERMISSION_LABOURRATE_READ,
  permissions.PERMISSION_LABOURRATE_UPDATE,
  permissions.PERMISSION_LABOURRATE_DELETE,

  permissions.PERMISSION_ORDERACCOUNT_READ,
  permissions.PERMISSION_ORDERACCOUNT_UPDATE,
  permissions.PERMISSION_ORDERACCOUNT_DELETE,

  permissions.PERMISSION_VEHICLE_CREATE,
  permissions.PERMISSION_VEHICLE_READ,
  permissions.PERMISSION_VEHICLE_UPDATE,
  permissions.PERMISSION_VEHICLE_DELETE,

  permissions.PERMISSION_WORKORDERLINE_STATUS_TOGGLE,

  permissions.PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE,

  permissions.PERMISSION_HISTORY,
  permissions.PERMISSION_VEHICLESALES_READ,
  permissions.PERMISSION_INVOICE_READ,

  permissions.PERMISSION_PART_CREATE,
  permissions.PERMISSION_PART_READ,
  permissions.PERMISSION_PART_UPDATE,
  permissions.PERMISSION_PART_DELETE,
  permissions.PERMISSION_GENART_ADD_FROM_STOCK,
  permissions.PERMISSION_WORKORDERLINE_PART_CREATE,

  permissions.PERMISSION_BACK_TO_WORK_ORDER_ARROW_BUTTON
]

const PermissionsModuleFleetLease = [permissions.PERMISSION_LEASECOMPANY, permissions.PERMISSION_LEASECOMPANY_DASHBOARD_WIDGET]

const PermissionsInternalInvoicing = [
  permissions.PERMISSION_ANY,
  permissions.PERMISSION_INTERNAL_INVOICING,

  permissions.PERMISSION_DEPARTMENTS_CREATE,
  permissions.PERMISSION_DEPARTMENTS_READ,
  permissions.PERMISSION_DEPARTMENTS_UPDATE,
  permissions.PERMISSION_DEPARTMENTS_DELETE,

  permissions.PERMISSION_EXPENSE_OF_CREATE,
  permissions.PERMISSION_EXPENSE_OF_READ,
  permissions.PERMISSION_EXPENSE_OF_UPDATE,
  permissions.PERMISSION_EXPENSE_OF_DELETE
]

export const ModulePermissions: { [key in Subscriptions]: string[] } = {
  [Subscriptions.Module_0]: PermissionsModule0,
  [Subscriptions.Module_FleetLease]: PermissionsModuleFleetLease,
  [Subscriptions.Module_GMS]: PermissionsModuleGMS,
  [Subscriptions.Module_Portal]: PermissionsModulePortal,
  [Subscriptions.Module_FleetLeaseWhiteLabel]: PermissionsModuleFleetLeaseWhiteLabel,
  [Subscriptions.Module_TimeRegistration]: PermissionsModuleTimeregistration,
  [Subscriptions.Module_VehicleSales]: PermissionsModuleVehicleSales,
  [Subscriptions.Module_TyreChange]: PermissionsModuleTyreChange,
  [Subscriptions.Module_CourtesyVehicles]: PermissionsModuleCourtesyVehicles,
  [Subscriptions.Module_RentalVehicles]: PermissionsModuleRentalVehicles,
  [Subscriptions.Module_CRM]: PermissionsModuleCRM,
  [Subscriptions.Module_InternalInvoicing]: PermissionsInternalInvoicing,
  [Subscriptions.Module_Support]: PermissionsModuleSupport,
  [Subscriptions.Module_AddOrderAccount]: [permissions.PERMISSION_ORDERACCOUNT_CREATE],
  [Subscriptions.Module_SwitchDefaultOrderAccount]: [permissions.PERMISSION_SWITCH_DEFAULT_ORDER_ACCOUNT],
  [Subscriptions.Module_Counter]: PermissionsModuleCounter
}
